import {Component, Input} from '@angular/core';
import {ProyectoItem, ProyectoTramiteItem} from '../../../interfaces/proyecto.interface';
import {ProyectoService} from "../../services/proyecto.service";

@Component({
    selector: 'app-info-tramites-proyecto',
    templateUrl: './info-tramites-proyecto.component.html',
    styleUrls: ['./info-tramites-proyecto.component.css']
})
export class InfoServiciosProyectoComponent {
    visible: boolean = false;
    public datosCargados: boolean = false;
    tramitesPorProyecto: ProyectoTramiteItem[] = []
    constructor(private proyecto: ProyectoService) {
    }
    showDialog() {
        this.visible = true;
        this.getRequisitos()
    }
    hiddeDialog() {
        this.visible = false;
        this.datosCargados = false;
    }
    private getRequisitos() {
        this.proyecto.getTramitesProyectos(this.idProyecto!)
            .subscribe({
                next: (result) => {
                    if (result.status == 200) {
                        this.datosCargados = true
                        this.tramitesPorProyecto = result.body!
                    }
                },
                error: (error) => {
                    console.log(error)
                }
            });
    }
    @Input()
    public nombreProyecto?: string = '';
    @Input()
    selected?: ProyectoItem | null = null;
    @Input()
    idProyecto: number | null = null
    @Input()
    cantidadTramites?: number | null = null
    title() {
        let tituloDialog = ''
        if (this.selected) {
            tituloDialog = `TRAMITES SOLICITADOS - SOLICITUD #${this.selected.numeroExpediente}`
        }
        return tituloDialog;
    }
}
